import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo_dark.png'
import _imports_1 from '@/assets/images/new/illustration.png'
import _imports_2 from '@/assets/images/step1.png'
import _imports_3 from '@/assets/images/sunpay/step1.png'
import _imports_4 from '@/assets/images/step3.png'
import _imports_5 from '@/assets/images/sunpay/step3.png'
import _imports_6 from '@/assets/images/icon-copy.png'
import _imports_7 from '../../assets/images/bg-gery.png'


_pushScopeId("data-v-8892f4c0")
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "ctx" }
const _hoisted_3 = { class: "brand" }
const _hoisted_4 = {
  key: 0,
  class: "logo"
}
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 0,
  src: "/images/sunpay.png"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_0
}
const _hoisted_8 = { class: "name font-bold" }
const _hoisted_9 = { class: "lang" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "content" }
const _hoisted_12 = {
  key: 0,
  class: "slogan animated fadeInLeft"
}
const _hoisted_13 = { class: "title font-bold" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { class: "illustration" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  draggable: "false"
}, null, -1)
const _hoisted_17 = { class: "desc" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "order" }
const _hoisted_20 = { class: "head" }
const _hoisted_21 = { class: "title font-bold" }
const _hoisted_22 = { class: "icon" }
const _hoisted_23 = {
  key: 0,
  src: _imports_2
}
const _hoisted_24 = {
  key: 1,
  src: _imports_3
}
const _hoisted_25 = { class: "tname" }
const _hoisted_26 = { class: "time" }
const _hoisted_27 = { class: "block" }
const _hoisted_28 = { class: "block" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "colon" }, ":", -1)
const _hoisted_30 = { class: "block" }
const _hoisted_31 = { class: "block" }
const _hoisted_32 = { class: "body" }
const _hoisted_33 = { class: "container" }
const _hoisted_34 = { class: "project" }
const _hoisted_35 = {
  key: 0,
  class: "list"
}
const _hoisted_36 = {
  key: 0,
  class: "item active"
}
const _hoisted_37 = { class: "info" }
const _hoisted_38 = { class: "icon" }
const _hoisted_39 = ["src", "alt"]
const _hoisted_40 = { class: "value" }
const _hoisted_41 = { class: "name" }
const _hoisted_42 = {
  key: 0,
  class: "item active"
}
const _hoisted_43 = /*#__PURE__*/_createStaticVNode("<div class=\"info\" data-v-8892f4c0><div class=\"icon\" data-v-8892f4c0><img src=\"/images/sunpay.png\" alt=\"Sun Pay\" data-v-8892f4c0></div><div class=\"value\" data-v-8892f4c0><div class=\"name\" data-v-8892f4c0>Sun Pay</div></div></div>", 1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = {
  key: 1,
  class: "item active"
}
const _hoisted_46 = /*#__PURE__*/_createStaticVNode("<div class=\"info\" data-v-8892f4c0><div class=\"icon\" data-v-8892f4c0><img src=\"/images/icon-logo.png\" alt=\"Klickl Pay\" data-v-8892f4c0></div><div class=\"value\" data-v-8892f4c0><div class=\"name\" data-v-8892f4c0>Klickl Pay</div></div></div>", 1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { class: "container" }
const _hoisted_49 = {
  key: 0,
  class: "project"
}
const _hoisted_50 = { class: "title" }
const _hoisted_51 = { class: "list" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "info" }
const _hoisted_54 = { class: "icon" }
const _hoisted_55 = ["src", "alt"]
const _hoisted_56 = { class: "value" }
const _hoisted_57 = { class: "name" }
const _hoisted_58 = {
  key: 1,
  class: "project"
}
const _hoisted_59 = { class: "title" }
const _hoisted_60 = { class: "list" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { class: "info" }
const _hoisted_63 = { class: "icon" }
const _hoisted_64 = ["src", "alt"]
const _hoisted_65 = { class: "value" }
const _hoisted_66 = { class: "name" }
const _hoisted_67 = {
  key: 0,
  class: "desc"
}
const _hoisted_68 = {
  key: 0,
  class: "extend"
}
const _hoisted_69 = {
  key: 0,
  class: "footer"
}
const _hoisted_70 = { class: "total" }
const _hoisted_71 = {
  key: 0,
  class: "item"
}
const _hoisted_72 = { class: "value" }
const _hoisted_73 = { class: "item" }
const _hoisted_74 = { class: "number font-bold" }
const _hoisted_75 = { class: "action font-bold" }
const _hoisted_76 = { class: "pay" }
const _hoisted_77 = { class: "head" }
const _hoisted_78 = { class: "title font-bold" }
const _hoisted_79 = { class: "icon" }
const _hoisted_80 = {
  key: 0,
  src: _imports_4
}
const _hoisted_81 = {
  key: 1,
  src: _imports_5
}
const _hoisted_82 = { class: "desc" }
const _hoisted_83 = { class: "body" }
const _hoisted_84 = { class: "container" }
const _hoisted_85 = {
  key: 0,
  class: "form"
}
const _hoisted_86 = { class: "label required" }
const _hoisted_87 = { class: "value" }
const _hoisted_88 = {
  key: 1,
  class: "result"
}
const _hoisted_89 = {
  key: 0,
  class: "project"
}
const _hoisted_90 = { class: "amount font-bold" }
const _hoisted_91 = { class: "desc" }
const _hoisted_92 = { class: "qrcode" }
const _hoisted_93 = { class: "subtitle" }
const _hoisted_94 = { class: "paycode" }
const _hoisted_95 = { class: "input border" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1)
const _hoisted_97 = [
  _hoisted_96
]
const _hoisted_98 = { class: "subtitle" }
const _hoisted_99 = { class: "paycode" }
const _hoisted_100 = { class: "input border" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1)
const _hoisted_102 = [
  _hoisted_101
]
const _hoisted_103 = { class: "tips" }
const _hoisted_104 = { key: 0 }
const _hoisted_105 = { key: 1 }
const _hoisted_106 = { class: "footer" }
const _hoisted_107 = { class: "action font-bold" }
const _hoisted_108 = {
  key: 1,
  class: "status"
}
const _hoisted_109 = {
  key: 0,
  class: "loader"
}
const _hoisted_110 = { class: "icon" }
const _hoisted_111 = ["src", "alt"]
const _hoisted_112 = { class: "name" }
const _hoisted_113 = { class: "amount" }
const _hoisted_114 = { class: "infos" }
const _hoisted_115 = { class: "label" }
const _hoisted_116 = { class: "value" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1)
const _hoisted_118 = [
  _hoisted_117
]
const _hoisted_119 = { key: 0 }
const _hoisted_120 = { class: "label" }
const _hoisted_121 = { class: "value" }
const _hoisted_122 = {
  key: 0,
  class: "channel"
}
const _hoisted_123 = ["src", "alt"]
const _hoisted_124 = { key: 1 }
const _hoisted_125 = { class: "label" }
const _hoisted_126 = { class: "value" }
const _hoisted_127 = { key: 2 }
const _hoisted_128 = { class: "label" }
const _hoisted_129 = { class: "value" }
const _hoisted_130 = { key: 0 }
const _hoisted_131 = { class: "label" }
const _hoisted_132 = { class: "value" }
const _hoisted_133 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1)
const _hoisted_134 = [
  _hoisted_133
]
const _hoisted_135 = { class: "line" }
const _hoisted_136 = { key: 0 }
const _hoisted_137 = { class: "label" }
const _hoisted_138 = { class: "value" }
const _hoisted_139 = ["onClick"]
const _hoisted_140 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "copy"
}, null, -1)
const _hoisted_141 = [
  _hoisted_140
]
const _hoisted_142 = { key: 5 }
const _hoisted_143 = { class: "label" }
const _hoisted_144 = { class: "value" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("img", { src: _imports_6 }, null, -1)
const _hoisted_146 = [
  _hoisted_145
]
const _hoisted_147 = { key: 6 }
const _hoisted_148 = { class: "label" }
const _hoisted_149 = { class: "value links" }
const _hoisted_150 = { key: 0 }
const _hoisted_151 = { class: "value full" }
const _hoisted_152 = { key: 1 }
const _hoisted_153 = { class: "tips" }
const _hoisted_154 = { key: 0 }
const _hoisted_155 = { key: 1 }
const _hoisted_156 = { class: "line" }
const _hoisted_157 = { key: 0 }
const _hoisted_158 = { class: "label" }
const _hoisted_159 = { class: "value" }
const _hoisted_160 = ["onClick"]
const _hoisted_161 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "copy"
}, null, -1)
const _hoisted_162 = [
  _hoisted_161
]
const _hoisted_163 = /*#__PURE__*/_createElementVNode("li", { class: "line" }, null, -1)
const _hoisted_164 = { class: "item" }
const _hoisted_165 = { class: "label" }
const _hoisted_166 = { class: "value" }
const _hoisted_167 = {
  key: 1,
  class: "action"
}
const _hoisted_168 = { class: "btn" }
const _hoisted_169 = ["action"]
const _hoisted_170 = ["value"]
const _hoisted_171 = ["value"]
const _hoisted_172 = ["value"]
const _hoisted_173 = ["value"]
const _hoisted_174 = ["value"]
const _hoisted_175 = ["value"]
const _hoisted_176 = ["value"]
const _hoisted_177 = ["value"]
const _hoisted_178 = ["src"]
const _hoisted_179 = { class: "copyright" }
const _hoisted_180 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:business@klicklpay.com" }, "business@klicklpay.com", -1)
const _hoisted_181 = {
  key: 0,
  class: "background"
}
const _hoisted_182 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: "background"
}, null, -1)
const _hoisted_183 = [
  _hoisted_182
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_popover = _resolveComponent("van-popover")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_van_count_down = _resolveComponent("van-count-down")!
  const _component_KP_INPUT = _resolveComponent("KP_INPUT")!
  const _component_KP_SELECT = _resolveComponent("KP_SELECT")!
  const _component_VueQrcode = _resolveComponent("VueQrcode")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["klickl-pay-cashier", [_ctx.data.dev]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.CashChannelList?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_ctx.CashChannelList[0].businessCashierLogo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.CashChannelList[0].businessCashierLogo,
                      alt: _ctx.CashChannelList[0].businessCashierName
                    }, null, 8, _hoisted_5))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.data.dev == 'sunpaysandbox' || _ctx.data.dev == 'sunpayprod')
                        ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                        : (_openBlock(), _createElementBlock("img", _hoisted_7))
                    ], 64))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("cashier.h1")), 1)
        ]),
        _createVNode(_component_van_popover, {
          show: _ctx.showPopover,
          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPopover = $event)),
          actions: _ctx.data.Languages,
          theme: "dark",
          onSelect: _ctx.changeLang
        }, {
          reference: _withCtx(() => [
            _createElementVNode("span", _hoisted_9, [
              _createElementVNode("img", {
                src: `/images/${_ctx.locale}.png`,
                alt: _ctx.locale
              }, null, 8, _hoisted_10),
              _createTextVNode(_toDisplayString(_ctx.getLangName), 1)
            ])
          ]),
          _: 1
        }, 8, ["show", "actions", "onSelect"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.data.dev !== 'sunpaysandbox' && _ctx.data.dev !== 'sunpayprod')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_i18n_t, {
                keypath: "cashier.payin",
                scope: "global"
              }, {
                br: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_i18n_t, {
                  keypath: "cashier.tip1",
                  scope: "global"
                }, {
                  br: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["payment", { ordered: _ctx.data.FormData.orderStatus !== 0 }])
      }, [
        (_ctx.data.FormData.orderStatus == 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["infos", { nexts: _ctx.step > 1 || _ctx.result }])
            }, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      (_ctx.data.dev !== 'sunpaysandbox' && _ctx.data.dev !== 'sunpayprod')
                        ? (_openBlock(), _createElementBlock("img", _hoisted_23))
                        : (_openBlock(), _createElementBlock("img", _hoisted_24))
                    ]),
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("cashier.paytype")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    false
                      ? (_openBlock(), _createBlock(_component_van_count_down, {
                          key: 0,
                          time: Number(_ctx.data.FormData.expiresIn) * 1000,
                          format: "mm:ss",
                          onFinish: _ctx.finish
                        }, {
                          default: _withCtx((timeData) => [
                            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.splitNumber(timeData.minutes)[0]), 1),
                            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.splitNumber(timeData.minutes)[1]), 1),
                            _hoisted_29,
                            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.splitNumber(timeData.seconds)[0]), 1),
                            _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.splitNumber(timeData.seconds)[1]), 1)
                          ]),
                          _: 1
                        }, 8, ["time", "onFinish"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      (_ctx.CashChannelList?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            (
                        _ctx.CashChannelList[0].businessCashierLogo &&
                          _ctx.CashChannelList[0].businessCashierName
                      )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("div", _hoisted_38, [
                                      _createElementVNode("img", {
                                        src: _ctx.CashChannelList[0].businessCashierLogo,
                                        alt: _ctx.CashChannelList[0].businessCashierName
                                      }, null, 8, _hoisted_39)
                                    ]),
                                    _createElementVNode("div", _hoisted_40, [
                                      _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.CashChannelList[0].businessCashierName), 1)
                                    ])
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (_ctx.data.dev === 'sunpaysandbox' || _ctx.data.dev === 'sunpayprod')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_44))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_47))
                                ], 64))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_48, [
                    (_ctx.CashChannelList?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t("cashier.payment")), 1),
                          _createElementVNode("div", _hoisted_51, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CashChannelList, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["item", { active: item.code == _ctx.data.FormData.channelCode }]),
                                key: item.code,
                                onClick: 
                        () => {
                          _ctx.data.FormData.channelCode = item.code;
                        }
                      
                              }, [
                                _createElementVNode("div", _hoisted_53, [
                                  _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("img", {
                                      src: item.icon,
                                      alt: item.code
                                    }, null, 8, _hoisted_55)
                                  ]),
                                  _createElementVNode("div", _hoisted_56, [
                                    _createElementVNode("div", _hoisted_57, _toDisplayString(item.name), 1)
                                  ])
                                ])
                              ], 10, _hoisted_52))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.PaymentTypeList?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.$t("cashier.paytype")), 1),
                          _createElementVNode("div", _hoisted_60, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PaymentTypeList, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["item", { active: _ctx.data.FormData.paymentType == item.supportedChannelType }]),
                                key: item.id,
                                onClick: 
                        () => {
                          _ctx.data.FormData.paymentType = item.supportedChannelType;
                          _ctx.data.FormData.transactionFee = item.transactionFee;
                        }
                      
                              }, [
                                _createElementVNode("div", _hoisted_62, [
                                  _createElementVNode("div", _hoisted_63, [
                                    _createElementVNode("img", {
                                      src: 
                              _ctx.data.InterfaceUI[item.supportedChannelType]?.icon ||
                                '~@/assets/images/icon-other.png'
                            ,
                                      alt: item.supportedChannelType
                                    }, null, 8, _hoisted_64)
                                  ]),
                                  _createElementVNode("div", _hoisted_65, [
                                    _createElementVNode("div", _hoisted_66, _toDisplayString(item.supportedChannelType), 1),
                                    false
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(_ctx.data.InterfaceUI[item.supportedChannelType]?.name ||
                                _ctx.$t("cashier.other")), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                false
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, _toDisplayString(_ctx.$t("cashier.fee")) + ": " + _toDisplayString(item.transactionFee), 1))
                                  : _createCommentVNode("", true)
                              ], 10, _hoisted_61))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 512), [
                    [_vShow, false]
                  ]),
                  (_ctx.CashChannelList?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                        _createElementVNode("div", _hoisted_70, [
                          false
                            ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.fee")), 1),
                                _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.data.FormData.transactionFee) + " " + _toDisplayString(_ctx.data.FormData.currency), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.total")), 1),
                            _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.data.FormData.amount?.toFixed(2)) + " " + _toDisplayString(_ctx.data.FormData.currency), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_75, [
                          (_ctx.data.FormData.cancelUrl)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "btn cancel",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.paymentUrl(_ctx.data.FormData.cancelUrl, 'CANCEL')))
                              }, _toDisplayString(_ctx.$t("cashier.cancel")), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: "btn next",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nextStep(true)))
                          }, _toDisplayString(_ctx.step == _ctx.steps ? _ctx.$t("cashier.pay") : _ctx.$t("cashier.next")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      (_ctx.data.dev !== 'sunpaysandbox' && _ctx.data.dev !== 'sunpayprod')
                        ? (_openBlock(), _createElementBlock("img", _hoisted_80))
                        : (_openBlock(), _createElementBlock("img", _hoisted_81))
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("cashier.payinfo")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.$t("cashier.desc")), 1)
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("div", _hoisted_84, [
                    (!_ctx.result)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.dynamicsFiledList.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dynamicsFiledList, (field, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "item full",
                                    key: index
                                  }, [
                                    _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.resverText(field?.field_name)), 1),
                                    _createElementVNode("div", _hoisted_87, [
                                      (field.type == 'text')
                                        ? (_openBlock(), _createBlock(_component_KP_INPUT, {
                                            key: 0,
                                            modelValue: _ctx.data.FormData[field.field_name],
                                            "onUpdate:modelValue": ($event: any) => (_ctx.data.FormData[field.field_name] = $event),
                                            type: 'text',
                                            expand: field?.expand,
                                            placeholder: field?.field_name
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "expand", "placeholder"]))
                                        : _createCommentVNode("", true),
                                      (field.type == 'select')
                                        ? (_openBlock(), _createBlock(_component_KP_SELECT, {
                                            key: 1,
                                            modelValue: _ctx.data.FormData[field.field_name],
                                            "onUpdate:modelValue": ($event: any) => (_ctx.data.FormData[field.field_name] = $event),
                                            index: index,
                                            "field-name": field.field_name,
                                            list: field.value,
                                            onChange: _ctx.onSelectChange
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "index", "field-name", "list", "onChange"]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_88, [
                          (
                        ['AlchemyPay'].includes(_ctx.data.FormData.channelCode) &&
                          ['QRIS', 'OVO', 'DIRECT'].includes(_ctx.data.FormData.paymentType)
                      )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                _createElementVNode("div", _hoisted_90, [
                                  _createTextVNode(_toDisplayString(_ctx.$t("cashier.pay")) + " ", 1),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.data.FormData.amount?.toFixed(2)) + " " + _toDisplayString(_ctx.data.FormData.currency), 1)
                                ]),
                                _createElementVNode("div", _hoisted_91, _toDisplayString(_ctx.$t("cashier.qrcode")), 1),
                                _createElementVNode("div", _hoisted_92, [
                                  _createVNode(_component_VueQrcode, {
                                    value: 
                            _ctx.data.FormData.paymentType == 'QRIS'
                              ? _ctx.data.FormData.extend.qrCode
                              : _ctx.data.FormData.extend.paymentCode || _ctx.data.FormData.extend.vaNumber
                          ,
                                    tag: "img",
                                    options: {
                            width: 180,
                            margin: 0
                          }
                                  }, null, 8, ["value"])
                                ]),
                                (_ctx.data.FormData.extend.paymentCode)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.$t("cashier.paymentCode")), 1),
                                      _createElementVNode("div", _hoisted_94, [
                                        _createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.data.FormData.extend.paymentCode || ""), 1),
                                        _createElementVNode("div", {
                                          class: "extend border",
                                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copy(_ctx.data.FormData.extend.paymentCode)))
                                        }, _hoisted_97)
                                      ])
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (_ctx.data.FormData.extend.vaNumber)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createElementVNode("div", _hoisted_98, _toDisplayString(_ctx.$t("cashier.vaNumber")), 1),
                                      _createElementVNode("div", _hoisted_99, [
                                        _createElementVNode("div", _hoisted_100, _toDisplayString(_ctx.data.FormData.extend.vaNumber || ""), 1),
                                        _createElementVNode("div", {
                                          class: "extend border",
                                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.copy(_ctx.data.FormData.extend.vaNumber)))
                                        }, _hoisted_102)
                                      ])
                                    ], 64))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_103, [
                                  (_ctx.data.FormData.paymentType == 'DIRECT')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_104, _toDisplayString(_ctx.$t("cashier.useBank", { name: _ctx.data.FormData.bankName })), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.data.FormData.paymentType == 'QRIS')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_105, _toDisplayString(_ctx.$t("cashier.useQRIS", { name: _ctx.data.FormData.paymentType })), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                  ]),
                  _createElementVNode("div", _hoisted_106, [
                    _createElementVNode("div", _hoisted_107, [
                      (!_ctx.result)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "btn cancel",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.nextStep(false)))
                          }, _toDisplayString(_ctx.$t("cashier.back")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.result && _ctx.data.FormData.cancelUrl)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "btn cancel",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.paymentUrl(_ctx.data.FormData.cancelUrl, 'CANCEL')))
                          }, _toDisplayString(_ctx.$t("cashier.cancel")), 1))
                        : _createCommentVNode("", true),
                      (!_ctx.result)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: _normalizeClass(["btn next", { disabled: _ctx.isDisableConfirm }]),
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.nextStep(true)))
                          }, _toDisplayString(_ctx.step == _ctx.steps ? _ctx.$t("cashier.pay") : _ctx.$t("cashier.next")), 3))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ], 2))
          : _createCommentVNode("", true),
        ([1, 2, 3, 4].includes(_ctx.data.FormData.orderStatus))
          ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
              (_ctx.data.FormData.orderStatus == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_109))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_110, [
                _createElementVNode("img", {
                  src: `/images/status/${_ctx.CashPayInOrderStatus[_ctx.data.FormData.orderStatus]}.png`,
                  alt: _ctx.CashPayInOrderStatus[_ctx.data.FormData.orderStatus]
                }, null, 8, _hoisted_111)
              ]),
              _createElementVNode("div", _hoisted_112, [
                _createTextVNode(_toDisplayString(_ctx.$t(`cashier.PayinStatus[${_ctx.data.FormData.orderStatus}]`)) + " ", 1),
                _createElementVNode("div", _hoisted_113, _toDisplayString(_ctx.data.FormData.currency) + " " + _toDisplayString(_ctx.data.FormData.amount?.toFixed(2)), 1)
              ]),
              _createElementVNode("div", _hoisted_114, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("div", _hoisted_115, _toDisplayString(_ctx.$t("cashier.orderNo")), 1),
                    _createElementVNode("div", _hoisted_116, [
                      _createTextVNode(_toDisplayString(_ctx.data.FormData.outOrderNo) + " ", 1),
                      _createElementVNode("span", {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.copy(_ctx.data.FormData.outOrderNo)))
                      }, _hoisted_118)
                    ])
                  ]),
                  false
                    ? (_openBlock(), _createElementBlock("li", _hoisted_119, [
                        _createElementVNode("div", _hoisted_120, _toDisplayString(_ctx.$t("cashier.channel")), 1),
                        _createElementVNode("div", _hoisted_121, [
                          (_ctx.data.FormData.channelIcon)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                                _createElementVNode("img", {
                                  src: _ctx.data.FormData.channelIcon,
                                  alt: _ctx.data.FormData.channelName
                                }, null, 8, _hoisted_123)
                              ]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.data.FormData.channelName || "--"), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.data.FormData.accountType)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_124, [
                        _createElementVNode("div", _hoisted_125, _toDisplayString(_ctx.$t("cashier.paymentType")), 1),
                        _createElementVNode("div", _hoisted_126, _toDisplayString(_ctx.data.FormData.accountType), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.data.FormData.bankName)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_127, [
                        _createElementVNode("div", _hoisted_128, _toDisplayString(_ctx.$t("cashier.bank")), 1),
                        _createElementVNode("div", _hoisted_129, _toDisplayString(_ctx.data.FormData.bankName), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.data.FormData.paymentCode)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (
                    _ctx.data.FormData.channelCode !== 'DukPay' ||
                      (_ctx.data.FormData.channelCode == 'DukPay' &&
                        ![_ctx.data.FormData.accountType, _ctx.data.FormData.paymentType].includes(
                          'BANKTRANSFER'
                        ))
                  )
                          ? (_openBlock(), _createElementBlock("li", _hoisted_130, [
                              _createElementVNode("div", _hoisted_131, _toDisplayString(_ctx.data.FormData.channelCode == "DukPay" &&
                      [_ctx.data.FormData.accountType, _ctx.data.FormData.paymentType].includes("SPEI")
                        ? "CLABE Code"
                        : _ctx.$t("cashier.paymentCode")), 1),
                              _createElementVNode("div", _hoisted_132, [
                                _createTextVNode(_toDisplayString(_ctx.data.FormData.paymentCode) + " ", 1),
                                _createElementVNode("span", {
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.copy(_ctx.data.FormData.paymentCode)))
                                }, _hoisted_134)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (
                  _ctx.data.FormData.channelCode == 'AkuPay' &&
                    _ctx.isCanSerialize(_ctx.data.FormData?.responseDescription)
                )
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        _createElementVNode("li", _hoisted_135, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.payToAccount")), 1)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(_ctx.data.FormData?.responseDescription), (val, key) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            val
                              ? (_openBlock(), _createElementBlock("li", _hoisted_136, [
                                  _createElementVNode("div", _hoisted_137, _toDisplayString(_ctx.resverText(key)), 1),
                                  _createElementVNode("div", _hoisted_138, [
                                    _createTextVNode(_toDisplayString(val) + " ", 1),
                                    _createElementVNode("div", {
                                      class: "copy",
                                      onClick: ($event: any) => (_ctx.copy(val))
                                    }, _hoisted_141, 8, _hoisted_139)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 256))
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.data.FormData.vaNumber)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_142, [
                        _createElementVNode("div", _hoisted_143, _toDisplayString(_ctx.$t("cashier.vaNumber")), 1),
                        _createElementVNode("div", _hoisted_144, [
                          _createTextVNode(_toDisplayString(_ctx.data.FormData.vaNumber) + " ", 1),
                          _createElementVNode("span", {
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.copy(_ctx.data.FormData.vaNumber)))
                          }, _hoisted_146)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.data.FormData.orderStatus == 1 && _ctx.data.FormData.checkoutUrl)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_147, [
                        _createElementVNode("div", _hoisted_148, _toDisplayString(_ctx.$t("cashier.link")), 1),
                        _createElementVNode("div", _hoisted_149, [
                          _createElementVNode("div", {
                            class: "a",
                            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.toPay && _ctx.toPay(...args)))
                          }, _toDisplayString(_ctx.$t("cashier.pay")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.data.FormData.qrCode || _ctx.data.FormData.paymentCode || _ctx.data.FormData.vaNumber)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                        (
                    _ctx.data.FormData.channelCode !== 'DukPay' ||
                      (_ctx.data.FormData.channelCode == 'DukPay' &&
                        ![_ctx.data.FormData.accountType, _ctx.data.FormData.paymentType].includes(
                          'BANKTRANSFER'
                        ))
                  )
                          ? (_openBlock(), _createElementBlock("li", _hoisted_150, [
                              _createElementVNode("div", _hoisted_151, [
                                _createVNode(_component_VueQrcode, {
                                  value: 
                        _ctx.data.FormData.accountType == 'QRIS'
                          ? _ctx.data.FormData.qrCode
                          : _ctx.data.FormData.paymentCode || _ctx.data.FormData.vaNumber
                      ,
                                  tag: "img",
                                  options: {
                        width: 140,
                        margin: 0
                      }
                                }, null, 8, ["value"])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.data.FormData.orderStatus == 1)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_152, [
                              _createElementVNode("div", _hoisted_153, [
                                (_ctx.data.FormData.accountType == 'DIRECT')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_154, _toDisplayString(_ctx.$t("cashier.useBank", { name: _ctx.data.FormData.bankName })), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.data.FormData.accountType == 'QRIS')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_155, _toDisplayString(_ctx.$t("cashier.useQRIS", { name: _ctx.data.FormData.accountType })), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (
                  _ctx.data.FormData.channelCode == 'DukPay' &&
                    [_ctx.data.FormData.accountType, _ctx.data.FormData.paymentType].includes('BANKTRANSFER')
                )
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                        _createElementVNode("li", _hoisted_156, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.payToAccount")), 1)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(_ctx.data.FormData.paymentCode), (val, key) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            val
                              ? (_openBlock(), _createElementBlock("li", _hoisted_157, [
                                  _createElementVNode("div", _hoisted_158, _toDisplayString(_ctx.resverText(key)), 1),
                                  _createElementVNode("div", _hoisted_159, [
                                    _createTextVNode(_toDisplayString(val) + " ", 1),
                                    _createElementVNode("div", {
                                      class: "copy",
                                      onClick: ($event: any) => (_ctx.copy(val))
                                    }, _hoisted_162, 8, _hoisted_160)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 256))
                      ], 64))
                    : _createCommentVNode("", true),
                  _hoisted_163,
                  _createElementVNode("li", _hoisted_164, [
                    _createElementVNode("div", _hoisted_165, _toDisplayString(_ctx.$t("cashier.orderTime")), 1),
                    _createElementVNode("div", _hoisted_166, _toDisplayString(_ctx.FormatDateZone(_ctx.data.FormData.creationAt) || "--"), 1)
                  ])
                ])
              ]),
              (_ctx.data.FormData.orderStatus == 1 && false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                    _createElementVNode("div", _hoisted_168, _toDisplayString(_ctx.$t("cashier.paid")), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.data.FormData.channelCode === 'LinkedPay')
          ? (_openBlock(), _createElementBlock("form", {
              key: 2,
              ref: "LinkedPayForm",
              action: _ctx.data.FormData.extend.checkoutUrl || _ctx.data.FormData.checkoutUrl,
              method: "post",
              target: "myIframe"
            }, [
              _createElementVNode("input", {
                type: "hidden",
                name: "merchantNo",
                value: _ctx.data.FormData.extend.merchantNo || _ctx.data.FormData.merchantNo
              }, null, 8, _hoisted_170),
              _createElementVNode("input", {
                type: "hidden",
                name: "merOrderNo",
                value: _ctx.data.FormData.extend.orderNo || _ctx.data.FormData.orderNo
              }, null, 8, _hoisted_171),
              _createElementVNode("input", {
                type: "hidden",
                name: "notifyUrl",
                value: _ctx.data.FormData.extend.notifyUrl || _ctx.data.FormData.notifyUrl
              }, null, 8, _hoisted_172),
              _createElementVNode("input", {
                type: "hidden",
                name: "ipAddress",
                value: 
                _ctx.data.FormData.customerIP || _ctx.data.FormData.extend.customerIP || '104.243.23.241'
              
              }, null, 8, _hoisted_173),
              _createElementVNode("input", {
                type: "hidden",
                name: "currencyCode",
                value: _ctx.data.FormData.currency
              }, null, 8, _hoisted_174),
              _createElementVNode("input", {
                type: "hidden",
                name: "amount",
                value: _ctx.data.FormData.amount
              }, null, 8, _hoisted_175),
              _createElementVNode("input", {
                type: "hidden",
                name: "returnUrl",
                value: 
                `${_ctx.data.FormData.extend.syncNotifyUrl ||
                  _ctx.data.FormData.syncNotifyUrl}${`${_ctx.data.path}/cashier/payin?k=${_ctx.data.token}`}`
              
              }, null, 8, _hoisted_176),
              _createElementVNode("input", {
                type: "hidden",
                name: "websiteUrl",
                value: _ctx.data.path
              }, null, 8, _hoisted_177)
            ], 8, _hoisted_169))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["close", { open: _ctx.iframeUrl || _ctx.showIframeUrl }]),
        onClick: _cache[12] || (_cache[12] = 
          () => {
            _ctx.iframeUrl = '';
            _ctx.showIframeUrl = false;
          }
        )
      }, [
        _createVNode(_component_van_icon, { name: "arrow-down" })
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["iframe", { open: _ctx.iframeUrl || _ctx.showIframeUrl }])
      }, [
        _createElementVNode("iframe", {
          src: _ctx.iframeUrl,
          frameborder: "0",
          name: "myIframe",
          id: "myIframe",
          seamless: ""
        }, null, 8, _hoisted_178)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_179, [
      (
          _ctx.CashChannelList?.length &&
            !_ctx.CashChannelList[0].businessCashierName &&
            _ctx.data.dev !== 'sunpaysandbox' &&
            _ctx.data.dev !== 'sunpayprod'
        )
        ? (_openBlock(), _createBlock(_component_i18n_t, {
            key: 0,
            keypath: "cashier.copyright",
            scope: "global"
          }, {
            mail: _withCtx(() => [
              _hoisted_180
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.data.dev !== 'sunpaysandbox' && _ctx.data.dev !== 'sunpayprod')
      ? (_openBlock(), _createElementBlock("div", _hoisted_181, _hoisted_183))
      : _createCommentVNode("", true)
  ], 2))
}